import React from 'react';
import cx from 'classnames';
import { USER_ROLE } from 'constants';
import { getUserRole, getTarifPeriodName } from 'utils';
import { useDispatch, useSelector } from 'react-redux';
import PayForTarifBtn from 'components/Payments/PayForTarifBtn';
import s from './style.scss';
import nothingFound from 'assets/images/nothingfound.png';
import { setPopUp } from 'actions/environment';
import { useTranslation } from 'react-i18next';
import LeaveAgencyDialog from '../Profile/LeaveAgency/LeaveAgencyDialog';
import { Link } from 'react-router-dom';
import { gaEvent, trackGA } from 'services/ga';

const Blocker = () => {
  const { t } = useTranslation();
  const { profile } = useSelector((state) => ({ profile: state.profile }));
  const { tariff, agencyName } = profile;
  const role = getUserRole(profile);
  const tarif = getTarifPeriodName(tariff.pricing);
  const dispatch = useDispatch();

  const handleClick = () => {
    trackGA(
      gaEvent.agencyNoAccessButtonsClick({
        eventLabel: 'vyiti_iz_agentstva',
        user_id: profile.id,
      })
    );

    dispatch(
      setPopUp(<LeaveAgencyDialog />, {
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false,
      })
    );
  };

  if (role === USER_ROLE.ADMIN) {
    return (
      <div className={s.BlockerWrap}>
        <div className={s.Blocker}>
          <div className={cx(s.BlockerText, s.Wide)}>
            <div className={s.BlockerTitle}>
              {t('components.blocker.admin.title', { agencyName })}
            </div>
            <div className={s.BlockerDescrip}>
              {t('components.blocker.admin.description', { tarif })}
            </div>
            <div className={s.BlockerManager}>
              <a href="tel:+79649450276">{t('components.blocker.admin.manager.phone')}</a>
              {t('components.blocker.admin.manager.name')}
            </div>
          </div>
          <div className={s.BlockerImage}>
            <img src={nothingFound} alt="" />
          </div>
        </div>
      </div>
    );
  }

  if (role === USER_ROLE.WORKER) {
    return (
      <div className={s.BlockerWrap}>
        <div className={s.Blocker}>
          <div className={cx(s.BlockerText, s.Wide)}>
            <div className={s.BlockerTitle}>
              {t('components.blocker.worker.title', { agencyName })}
            </div>
            <div className={s.BlockerDescrip}>
              {t('components.blocker.worker.description', { tarif, agencyName })}
            </div>
            <Link
              to="/logout"
              onClick={() => {
                trackGA(
                  gaEvent.agencyNoAccessButtonsClick({
                    eventLabel: 'vyiti_iz_akkaunta',
                    user_id: profile.id,
                  })
                );
              }}
            >
              <button className={cx(s.ButtonLogout, 'button-primary', 'button-primary--lg')}>
                {t('components.profile.profileForm.logout')}
              </button>
            </Link>
            <button
              className={cx(s.ButtonLeave, 'button-default', 'button-primary--lg')}
              onClick={handleClick}
            >
              {t('components.profile.profileForm.leaveAgency')}
            </button>
          </div>
          <div className={s.BlockerImage}>
            <img src={nothingFound} alt="" />
          </div>
        </div>
      </div>
    );
  }

  if (role === USER_ROLE.INDIVIDUAL) {
    return (
      <div className={s.BlockerWrap}>
        <div className={s.Blocker}>
          <div className={s.BlockerText}>
            <div className={s.BlockerTitle}>{t('components.blocker.individual.title')}</div>
            <div className={s.BlockerDescrip}>
              {t('components.blocker.individual.description', { tarif })}
            </div>
            <PayForTarifBtn className={s.PayForTarifBtn}>
              {t('components.blocker.individual.pay')}
            </PayForTarifBtn>
          </div>
          <div className={s.BlockerImage}>
            <img src={nothingFound} alt="" />
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default Blocker;



// WEBPACK FOOTER //
// ./src/components/Blocker/Blocker.js